(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('LocationInfoCustom', LocationInfoCustom);

    LocationInfoCustom.$inject = ['$resource'];

    function LocationInfoCustom($resource) {


        var saveWithCompany = function () {

            var resourceUrl = 'api/location-info-with-company';
            return $resource(resourceUrl, {}, {});
        };


        return {
            saveWithCompany: saveWithCompany
        };
    }
})();
